import { render, staticRenderFns } from "./setChooseTextByText.vue?vue&type=template&id=41009966&scoped=true"
import script from "./setChooseTextByText.vue?vue&type=script&lang=js"
export * from "./setChooseTextByText.vue?vue&type=script&lang=js"
import style0 from "./setChooseTextByText.vue?vue&type=style&index=0&id=41009966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41009966",
  null
  
)

export default component.exports